import { formatMoney, type Currency } from '@gills/shared';

export function price(minor: number, currency: Currency = 'GBP'): string {
  return formatMoney(minor, currency);
}

export function priceOrFree(minor: number, currency: Currency = 'GBP'): string {
  return formatMoney(minor, currency, { showZeroAsFree: true });
}

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(iso));
}

/** "1–2 working days", or "3–7 working days". */
export function deliveryEstimate(min: number, max: number): string {
  return min === max
    ? `${min} working day${min === 1 ? '' : 's'}`
    : `${min}–${max} working days`;
}

/** Percentage saved, for the sale badge. */
export function discountPercent(priceMinor: number, compareAtMinor: number): number {
  if (compareAtMinor <= 0 || compareAtMinor <= priceMinor) return 0;
  return Math.round(((compareAtMinor - priceMinor) / compareAtMinor) * 100);
}

const COUNTRY_NAMES = new Intl.DisplayNames(['en-GB'], { type: 'region' });

export function countryName(code: string): string {
  try {
    return COUNTRY_NAMES.of(code.toUpperCase()) ?? code;
  } catch {
    return code;
  }
}
